import { ACCELERATION_COEFFECIENT } from '@/constants';


class Accelerator {
	constructor(items, duration, linear = false) {
		this.items = items;
		this.itemCount = items.length;
		this.duration = duration;
		this.linear = linear;
		this.elapsedTime = 0;
	}

	getInterval() {
		let interval = 0;

		if (this.linear) {
			interval = this.calcLinearInterval();
		} else {
			interval = this.calcAsymptotalInterval();
		}

		this.elapsedTime += interval;

		return interval;
	}

	calcLinearInterval() {
		return this.duration / this.itemCount;
	}

	getItem() {
		return this.items.splice(0, 1)[0];
	}

	getItems() {
		return this.items;
	}

	hasItems() {
		return this.items.length > 0;
	}

	calcAsymptotalInterval() {
		return (this.duration - this.elapsedTime) /
			((ACCELERATION_COEFFECIENT - (ACCELERATION_COEFFECIENT ** -(this.itemCount - 1)))
			/ (ACCELERATION_COEFFECIENT - 1));
	}
}

export default Accelerator;



// WEBPACK FOOTER //
// ./src/mixins/accelerator.js